import Config from '../../config';
import {
  handleErrors,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';

import { allCountries } from './constants';

export const fetchBookToTaxDifferences = periodName => fetch(
  Config.endpoints.FETCH_ADMIN_BOOK_TO_TAX_DIFFERENCES
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching Book To Tax Differences failed' }))
  .then(parseAsJson);

export const removeBookToTaxDifference = ({ exceptionId, periodName }) => fetch(
  Config.endpoints.DELETE_ADMIN_BOOK_TO_TAX_DIFFERENCES
    .replace(/:periodName/, periodName)
    .replace(/:exceptionId/, exceptionId),
  {
    method: 'DELETE',
  }
)
  .then(handleErrors({ errorMessage: 'Deleting Book To Tax Differences failed' }));


export const batchUpdateBookToTaxDifferences = (bookToTaxDifferences, { periodName }) => fetch(
  Config.endpoints.BATCH_UPDATE_ADMIN_BOOK_TO_TAX_DIFFERENCES
    .replace(/:periodName/, periodName),
  {
    method: 'PUT',
    body: JSON.stringify(bookToTaxDifferences),
  }
)
  .then(handleErrors({ errorMessage: 'Updating Book To Tax Differences failed' }));

export const addBookToTaxDifference = (bookToTaxDifference, { periodName }) => fetch(
  Config.endpoints.ADD_ADMIN_BOOK_TO_TAX_DIFFERENCES
    .replace(/:periodName/, periodName),
  {
    method: 'POST',
    body: JSON.stringify(bookToTaxDifference),
  }
)
  .then(handleErrors({ errorMessage: 'Adding Book To Tax Differences failed' }));

export const fetchBookToTaxCodeDescriptions = ({ periodName }) => fetch(
  Config.endpoints.FETCH_BOOK_TO_TAX_CODE_DESCRIPTIONS
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetch Book To Tax Code Descriptions failed' }))
  .then(parseAsJson);

export const refreshBookToTaxDifferences = ({ periodName }) => fetch(
  Config.endpoints.REFRESH_ADMIN_BOOK_TO_TAX_DIFFERENCES
    .replace(/:periodName/, periodName),
  {
    method: 'POST',
  }
)
  .then(handleErrors({ errorMessage: 'Refreshing Book To Tax Differences failed' }));


export const validateBookToTaxDifferences = (bookToTaxDifferences, { periodName }) => fetch(
  Config.endpoints.VALIDATE_ADMIN_BOOK_TO_TAX_DIFFERENCES
    .replace(/:periodName/, periodName),
  {
    method: 'POST',
    body: JSON.stringify(bookToTaxDifferences),
  }
)
  .then(handleErrors({ errorMessage: 'Validating Book To Tax Differences failed' }))
  .then(parseAsJson);

export const importBookToTaxDifferences = (bookToTaxDifferences, { periodName }) => fetch(
  Config.endpoints.IMPORT_ADMIN_BOOK_TO_TAX_DIFFERENCES
    .replace(/:periodName/, periodName),
  {
    method: 'POST',
    body: JSON.stringify(bookToTaxDifferences),
  }
)
  .then(handleErrors({ errorMessage: 'Importing Book To Tax Differences failed' }));

export const fetchCountries = () => fetch(Config.endpoints.FETCH_COUNTRIES)
  .then(handleErrors({ errorMessage: 'Fetching Countries failed' }))
  .then(parseAsJson)
  .then(countries => [allCountries, ...countries]);
